import { default as conditioner } from 'conditioner-core/conditioner-core';
import modules from './components/modules';
// Vite supports glob imports, but for better overview of the project we are using a central file to export all modules
// If you want to use glob imports, uncomment the line below and remove the modules file
// const modules = import.meta.glob('./components/**/*.js');

// initialize tickers
import './utils/ticker/ticker-observer';

// initialize tracking
import './tracking/main';

conditioner.addPlugin({
	moduleGetConstructor: (Module) => (element) => {
		if (!Module) {
			console.error(`Module for "${element.dataset.module}" does not exist`);

			return false;
		}

		return new Module(element).start();
	},
	moduleImport: (name) => Promise.resolve(modules[name]),
});

export default function start() {
	return {
		loader: conditioner.hydrate(document.body),
	};
}
